let MESSAGE = {}

// 203广播消息
MESSAGE[(MESSAGE["SIGANL_ID_BORDERCASTEVENT"] = "203")] =
  "SIGANL_ID_BORDERCASTEVENT"
// 208互动课件
MESSAGE[(MESSAGE["SIGANL_ID_INTERACTIVE"] = "208")] = "SIGANL_ID_INTERACTIVE"
MESSAGE[(MESSAGE["SIGANL_TYPE_ENTERSIGNALROOM"] = "2")] =
  "SIGANL_TYPE_ENTERSIGNALROOM"
MESSAGE[(MESSAGE["SIGANL_TYPE_LEAVESIGNALROOM"] = "3")] =
  "SIGANL_TYPE_LEAVESIGNALROOM"
// ppt翻页
MESSAGE[(MESSAGE["SIGANL_TYPE_PPTTURNINGPAGE"] = "9")] =
  "SIGANL_TYPE_PPTTURNINGPAGE"
MESSAGE[(MESSAGE["SIGANL_TYPE_PPTDRAWLINE"] = "10")] = "SIGANL_TYPE_PPTDRAWLINE"
MESSAGE[(MESSAGE["SIGANL_TYPE_PPTCLEAR"] = "11")] = "SIGANL_TYPE_PPTCLEAR"
MESSAGE[(MESSAGE["SIGANL_TYPE_CHANGEPPT"] = "12")] = "SIGANL_TYPE_CHANGEPPT"
MESSAGE[(MESSAGE["SIGANL_TYPE_OPENVIDEO"] = "13")] = "SIGANL_TYPE_OPENVIDEO"
MESSAGE[(MESSAGE["SIGANL_TYPE_CLOSEVIDEO"] = "14")] = "SIGANL_TYPE_CLOSEVIDEO"
MESSAGE[(MESSAGE["SIGANL_TYPE_SILENCEALL"] = "19")] = "SIGANL_TYPE_SILENCEALL"
MESSAGE[(MESSAGE["SIGANL_TYPE_ENABLECHAT"] = "20")] = "SIGANL_TYPE_ENABLECHAT"
MESSAGE[(MESSAGE["SIGANL_TYPE_ANNOUNCEMENT"] = "34")] =
  "SIGANL_TYPE_ANNOUNCEMENT"
MESSAGE[(MESSAGE["SIGANL_TYPE_SLIENCESOMEONE"] = "36")] =
  "SIGANL_TYPE_SLIENCESOMEONE"
MESSAGE[(MESSAGE["SIGANL_TYPE_ENABLESOMEONETALK"] = "37")] =
  "SIGANL_TYPE_ENABLESOMEONETALK"
MESSAGE[(MESSAGE["SIGANL_TYPE_SETMSGINTERVAL"] = "40")] =
  "SIGANL_TYPE_SETMSGINTERVAL"
MESSAGE[(MESSAGE["SIGANL_TYPE_CHATMESSAGE"] = "41")] = "SIGANL_TYPE_CHATMESSAGE"
MESSAGE[(MESSAGE["SIGANL_TYPE_SHOWUSERCOUNT"] = "42")] =
  "SIGANL_TYPE_SHOWUSERCOUNT"
MESSAGE[(MESSAGE["SIGANL_TYPE_HIDEUSERCOUNT"] = "43")] =
  "SIGANL_TYPE_HIDEUSERCOUNT"
MESSAGE[(MESSAGE["SIGANL_TYPE_INITMP4"] = "44")] = "SIGANL_TYPE_INITMP4"
MESSAGE[(MESSAGE["SIGANL_TYPE_SEEKMP4"] = "45")] = "SIGANL_TYPE_SEEKMP4"
MESSAGE[(MESSAGE["SIGANL_TYPE_PAUSEMP4"] = "46")] = "SIGANL_TYPE_PAUSEMP4"
MESSAGE[(MESSAGE["SIGANL_TYPE_PLAYMP4"] = "47")] = "SIGANL_TYPE_PLAYMP4"
MESSAGE[(MESSAGE["SIGANL_TYPE_CLOSEMP4"] = "49")] = "SIGANL_TYPE_CLOSEMP4"
MESSAGE[(MESSAGE["SIGANL_TYPE_SWITCHSCREEN"] = "53")] =
  "SIGANL_TYPE_SWITCHSCREEN"
// 发起答题
MESSAGE[(MESSAGE["SIGANL_TYPE_INTERACTIVE_STARTQUIZ"] = "71")] =
  "SIGANL_TYPE_INTERACTIVE_STARTQUIZ"
MESSAGE[(MESSAGE["SIGANL_TYPE_INTERACTIVE_ANSWER"] = "72")] =
  "SIGANL_TYPE_INTERACTIVE_ANSWER"
MESSAGE[(MESSAGE["SIGANL_TYPE_INTERACTIVE_COLLECTANSWERS"] = "73")] =
  "SIGANL_TYPE_INTERACTIVE_COLLECTANSWERS"
MESSAGE[(MESSAGE["SIGANL_TYPE_CUSTOM_MESSAGE"] = "80")] =
  "SIGANL_TYPE_CUSTOM_MESSAGE"

export default MESSAGE
